import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons/faGripDotsVertical';
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import messages from './messages';
import classnames from 'classnames';
import { AllocationRulesContext } from './context';
import style from './style.module.less';

const ReadOnlyRuleBody = ({
  dragProvided,
  allocationRuleId,
  ruleName,
  rulePrioritizationText,
  onOpenConfirmation,
  hasAllocationRuleInEdit,
}) => {
  const { setRuleIdInEdit } = useContext(AllocationRulesContext);
  const onSetInEdit = useCallback(() => {
    setRuleIdInEdit(allocationRuleId);
  }, [allocationRuleId, setRuleIdInEdit]);

  return (
    <div className={classnames(style['head-or-item'], style.item)}>
      <div className={style.task}>
        <div className={style['rule-grabber']} {...dragProvided.dragHandleProps}>
          <FontAwesomeIcon icon={faGripDotsVertical} />
        </div>
        <div className={classnames({ [style.locked]: hasAllocationRuleInEdit })}>{ruleName}</div>
      </div>
      <div
        className={classnames(style.prioritize, {
          [style.locked]: hasAllocationRuleInEdit,
        })}
      >
        {rulePrioritizationText}
      </div>
      <div className={style['rule-actions']}>
        <div>
          <Button disabled={hasAllocationRuleInEdit} onClick={onSetInEdit} theme='link'>
            <FormattedMessage {...messages.allocationStrategiesEdit} />
          </Button>
        </div>
        <div>
          <Button disabled={hasAllocationRuleInEdit} onClick={onOpenConfirmation} theme='link'>
            <FormattedMessage {...messages.allocationStrategiesRemove} />
          </Button>
        </div>
      </div>
    </div>
  );
};

ReadOnlyRuleBody.propTypes = {
  dragProvided: PropTypes.object.isRequired,
  allocationRuleId: PropTypes.string.isRequired,
  ruleName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  rulePrioritizationText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onOpenConfirmation: PropTypes.func.isRequired,
  hasAllocationRuleInEdit: PropTypes.bool.isRequired,
};

export default ReadOnlyRuleBody;
